/* global google */
import loadScript from '@PROJECT_ROOT/assets/shared/js/library/scriptLoader';
import fetchStateFromHtml from '@PROJECT_ROOT/assets/shared/js/fetchStateFromHtml';

export default function loadGoogleMaps() {
    if (googleMapsAlreadyLoaded()) {
        return Promise.resolve(google);
    }
    return loadScript(fetchStateFromHtml('commonState').googleMapsApiURL).then(() => google);
}

function googleMapsAlreadyLoaded() {
    return typeof google === 'object' && typeof google.maps === 'object' && typeof google.maps.places === 'object';
}
